// extracted by mini-css-extract-plugin
export default {"whatIsNear":"WhatIsNear_whatIsNear__yEVEe","whatIsNearContainer":"WhatIsNear_whatIsNearContainer__DH+hZ"};